import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

import {
  CommonProductService,
  ICommonProductService,
} from '@dewise-devex/backstage-plugin-product-common';

export const commonProductApiRef = createApiRef<ICommonProductService>({
  id: 'plugin.achievements.product.common',
});

export const productPlugin = createPlugin({
  id: 'achievements',
  apis: [
    createApiFactory({
      api: commonProductApiRef,
      deps: {
        identityApi: identityApiRef,
        discoveryApi: discoveryApiRef,
      },
      factory: deps => new CommonProductService(deps),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const ProductsPage = productPlugin.provide(
  createRoutableExtension({
    name: 'ProductsPage',
    component: () =>
      import('./components/Achievements').then(m => m.Achievements),
    mountPoint: rootRouteRef,
  }),
);
